<template>
  <Modal v-model="orderTrajectoryModal" :title="$t('key1006046')" width="700" :transfer="false" :mask-closable="true">
    <!--列表区域-->
    <div class="table-box">
      <Table
        border
        max-height="600"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <template #footer>
      <Button type="primary" @click="orderTrajectoryModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getAllYmsWarehouseData, getQueryCarrierShippingName, getYunLogisticsAll, jumpToTheCourierInquiry, setConfigCharacters} from "@/utils/common";

export default {
  name: "orderTrajectoryModal",
  mixins: [Mixin],
  props: {
    shippingMethodList: {
      type: Array,
      default: () => []
    },
    form: {
      type: String,
      default: 'myOrder'
    }
  },
  data() {
    let v = this;
    return {
      yunShipList: [],
      orderTrajectoryModal: false,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006034'),
          key: 'orderTrajectory',
          align: 'left',
          minWidth: 400,
          render(h, params) {
            return h('span', {
              domProps: {
                innerHTML: params.row.name
              },
              on: {
                click(event) {
                  const customAttributeValue = event.target.getAttribute('data-expressageNo');
                  if (customAttributeValue) {
                    jumpToTheCourierInquiry(v.expressageCode, v.expressageNo, v.trackingNumber);
                  }
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002451'),
          key: 'time',
          align: 'left',
          minWidth: 180,
        }
      ],
      tableData: [],
      originalData: [
        {sort: 1, value: 0, key: 'createdTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799')},
        {sort: 2, value: 13, key: 'createdTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001801')},
        {sort: 3, value: 1, key: 'printTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006035')},
        {sort: 4, value: 2, key: 'pickingFinishTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006036')},
        {sort: 5, value: 3, key: 'packingTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006037')},
        {sort: 6, value: 4, key: 'supperBoxedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006038')},
        {sort: 7, value: 5, key: 'despatchTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006039')},
        {sort: 8, value: 11, key: 'allottedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001807')},
        {sort: 9, value: 6, key: 'allottedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006040')},
        {sort: 10, value: 7, key: 'pickedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006041')},
        {sort: 11, value: 8, key: 'changedLabelTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006042')},
        {sort: 12, value: 9, key: 'boxedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006043')},
        {sort: 13, value: 10, key: 'shipedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006044')},
        {sort: 14, value: 12, key: 'cancelledTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006045')},
      ],
      shippingMethodData: [],
      expressageNo: null,
      expressageCode: null,
      trackingNumber: null,
    };
  },
  methods: {
    // 初始化数据
    initOrderTrajectoryData(data) {
      let ymsWarehouseName = '';
      let v = this;
      v.expressageNo = data.expressageNo;
      v.expressageCode = data.expressageCode;
      v.trackingNumber = data.subTrackingNumber;
      v.shippingMethodData = [];
      getYunLogisticsAll().then((newList) => {
        v.yunShipList = newList;
        getAllYmsWarehouseData().then((list) => {
          if (list.length > 0) {
            list.map((item) => {
              if (item.ymsWarehouseId === data.ymsWarehouseId) {
                ymsWarehouseName = item.name;
              }
            });
            if (v.form === 'platformOrder') {
              if (data.shippingMethodId) {
                getQueryCarrierShippingName([data.shippingMethodId]).then((shippingMethodList) => {
                  v.shippingMethodData = shippingMethodList;
                  handleData();
                });
              } else {
                handleData();
              }
            } else {
              v.shippingMethodData = v.shippingMethodList;
              handleData();
            }
          }
        });
      });

      function handleData() {
        v.tableData = [];
        let trajectoryStatusList = data.trajectoryStatusList || [];
        let needPurchaseTalg = data.needPurchase === 0; // 0 YMS订单不需要采购 (不用展示供应商的备货状态)
        let transportType = Number(data.transportType); // 交货方式: 1快递至揽收点  2上门揽收
        let list = needPurchaseTalg ? v.originalData.filter((item) => {
          return ![1, 2, 3, 4, 5].includes(item.value);
        }) : v.originalData;
        if (trajectoryStatusList.length > 0) {
          trajectoryStatusList.map((item) => {
            list.map((ele) => {
              if (item.value === ele.value) {
                let name = '';
                if (data[item.key]) {
                  switch (item.key) {
                    case 'supperBoxedTime':
                      let text = '';
                      // 上门揽收
                      if (transportType === 2) {
                        text = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006033')}`;
                        name = text.replace('ymsWarehouseName', ymsWarehouseName);
                      } else {
                        text = ele.name.replace('ymsWarehouseName', ymsWarehouseName);
                        name = text.replace('expressageNo', `<span class="distributorThemeColor cursor" data-expressageNo="true">${data.expressageNo}</span>`);
                      }
                      break;
                    case 'despatchTime':
                      name = ele.name.replace('ymsWarehouseName', ymsWarehouseName);
                      break;
                    case 'allottedTime':
                      name = ele.name.replace('ymsWarehouseName', ymsWarehouseName);
                      break;
                    case 'boxedTime':
                      let shippingMethodName = '';
                      let ymsLogisServiceId = data.ymsLogisServiceId;
                      // YMS物流
                      if (ymsLogisServiceId) {
                        if (v.yunShipList.length > 0) {
                          v.yunShipList.map((item) => {
                            if (item.ymsLogisServiceId === ymsLogisServiceId) {
                              shippingMethodName = item.name;
                            }
                          });
                        }
                      }
                      // 基础物流
                      else {
                        if (v.shippingMethodList.length > 0) {
                          v.shippingMethodList.map((item) => {
                            if (item.shippingMethodId === data.shippingMethodId) {
                              let carrierName = item.carrierName;
                              let carrierShippingMethodName = item.carrierShippingMethodName;
                              shippingMethodName = carrierName + (carrierShippingMethodName ? ' > ' + carrierShippingMethodName : '');
                            }
                          });
                        }
                      }
                      name = ele.name.replace('shippingMethodName', shippingMethodName);
                      break;
                    default:
                      name = ele.name;
                  }
                  let obj = {
                    time: v.$uDate.dealTime(data[item.key], 'fulltime'),
                    name: name
                  };
                  v.tableData.push(obj);
                }
              }
            });
          });
        }
        v.orderTrajectoryModal = true;
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>